export default async function to(promise, errorExt) {
  try {
    const data = await promise
    return [null, data]
  } catch (err) {
    if (errorExt) Object.assign(err, errorExt)
    return [err, undefined]
  }
}
